import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Value of Change by Epic',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Value of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'High',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'highDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'highDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'highBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'highGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'highMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'highGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'highProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'highStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'highBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'highTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'highTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Medium',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'mediumDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'mediumDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'mediumBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'mediumGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'mediumMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'mediumGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'mediumProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'mediumStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'mediumBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'mediumTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'mediumTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Low',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'lowDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'lowDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'lowBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'lowGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'lowMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'lowGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'lowProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'lowStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'lowBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'lowTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'lowTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Epic',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    lowDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
